const mutations = {
  setConfigurationFilters(state, payload) {
    state.configurationFilters = payload;
  },
  setAchievementClubbingData(state, payload) {
    state.achievmentClubbingData = payload;
  },
  setProDataSetupData(state, payload) {
    state.proDataSetupData = payload;
  },
  setBranchOptions(state,payload){
    state.branchDropdownOptions=payload;
  },
  setJobLists(state, payload) {
    state.jobLists = payload;
  },
  setGroupTypeList(state, payload) {
    state.groupTypeLists = payload;
  },
};

export default mutations;
